import React, { useState } from "react";

const branches = [
  {
    city: "Anand (H.O)",
    address: {
      line1: "M S House",
      area: "Anand - Vidyanagar Rd, near Panchal Hall, Vivekanand Wadi",
      city: "Anand",
      state: "Gujarat",
      pincode: "388120",
    },
  },
  {
  city: "Vancouver (Canada)",
  address: {
    line1: "2110, 650 West Georgia Street",
    area: "",
    city: "Vancouver",
    state: "British Columbia",
    pincode: "V6B 4N8",
  },
},
  {
    city: "Ahmedabad (Navrangpura)",
    address: {
      line1: "6th Floor, Vishwanath North View Complex",
      area: "Opp. LD Hostel, University Road, Gulbai Tekra",
      city: "Ahmedabad",
      state: "Gujarat",
      pincode: "380006",
    },
  },
  {
    city: "Ahmedabad (Maninagar)",
    address: {
      line1: "3rd Floor, Sigma Esquire",
      area: "Lala Lajpat Rai Marg, Opposite Kankaria Lake",
      city: "Ahmedabad",
      state: "Gujarat",
      pincode: "380028",
    },
  },
  {
    city: "Surat",
    address: {
      line1: "International Finance Centre, Office 905",
      area: "VIP Road, Vesu",
      city: "Surat",
      state: "Gujarat",
      pincode: "395007",
    },
  },
  {
    city: "Vadodara",
    address: {
      line1: "A1, First Floor, Rama Krishna Chambers",
      area: "Vishwas Colony, Vadiwadi",
      city: "Vadodara",
      state: "Gujarat",
      pincode: "390007",
    },
  },
  {
    city: "Navsari",
    address: {
      line1: "2nd Floor, Bhagwandas Complex",
      area: "Near Manav Mandir, Lunsikui",
      city: "Navsari",
      state: "Gujarat",
      pincode: "396445",
    },
  },
  {
    city: "Nadiad",
    address: {
      line1: "Nexus-1, Offices 308–309",
      area: "Uttarsanda Road",
      city: "Nadiad",
      state: "Gujarat",
      pincode: "387370",
    },
  },
  {
  city: "Mumbai",
  phone: "98242 21447 | 70413 21447",
  address: {
    line1: "603-A, Lodha Signet",
    area: "Kolshet Road, Thane - West",
    city: "Thane",
    state: "Maharashtra",
    pincode: "400607",
  },
},
{
  city: "Rajkot",
  phone: "98242 21447 | 98242 13447 | 93273 16196",
  address: {
    line1: "403, Princess Crown",
    area: "Nr. Kotecha Over Bridge, Kalavad Road",
    city: "Rajkot",
    state: "Gujarat",
    pincode: "360005",
  },
},
  {
    city: "Borsad",
    address: {
      line1: "2nd Floor, Shiv Icon",
      area: "Anand Chowkdi, Kesav Nagar, Ramnath Society",
      city: "Borsad",
      state: "Gujarat",
      pincode: "388540",
    },
  },
];

export default function ContactPage() {
  const [selectedOffice, setSelectedOffice] = useState("");

  const filteredBranches = selectedOffice
    ? branches.filter((branch) =>
        branch.city.toLowerCase().includes(selectedOffice.toLowerCase())
      )
    : branches;

  return (
    <div className="bg-light-gray">
      {/* Banner Section */}
      <header className="bg-primary text-white py-16 px-6">
        <div className="container mx-auto text-center">
          <h1 className="text-4xl font-bold">Contact Us</h1>
          <p className="mt-4 text-lg">
            Book your FREE consultation with Certified Counsellors
          </p>
        </div>
      </header>

      {/* Offices Section */}
      <section className="py-10">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-semibold">Offices in India</h2>
            <select
              value={selectedOffice}
              onChange={(e) => setSelectedOffice(e.target.value)}
              className="border border-gray-300 rounded-md p-2"
            >
              <option value="">Select Office</option>
              {branches.map((branch, index) => (
                <option key={index} value={branch.city}>
                  {branch.city}
                </option>
              ))}
            </select>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredBranches.map((branch, index) => (
              <div
                key={index}
                className="bg-white shadow-md p-5 rounded-lg border border-gray-200 hover:shadow-lg transition-shadow"
              >
                <h3 className="text-lg font-bold mb-2">{branch.city}</h3>

                <p className="text-sm text-gray-700 leading-relaxed">
                  📍 {branch.address.line1},<br />
                  {branch.address.area},<br />
                  {branch.address.city}, {branch.address.state} –{" "}
                  {branch.address.pincode}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer className="bg-gray-100 py-10">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-start">
          <div className="mb-6 md:mb-0">
            <h4 className="text-xl font-semibold mb-4">Head Office</h4>
            <p className="text-sm text-gray-800 mb-2">
              M S House, Anand - Vidyanagar Rd,<br />
              Near Panchal Hall, Anand, Gujarat 388120
            </p>
            <p className="text-sm text-gray-800 mb-2">
              Monday to Saturday: 9:30 AM to 6:30 PM<br />
              Sunday: Closed
            </p>
          </div>

          <div className="w-full md:w-1/2 h-64">
            <iframe
              title="M.S. Education Consultant Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.6756107980245!2d72.94428057512604!3d22.553821279505087!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e4e8087d820e1%3A0x13676ea149398be1!2sM.S.%20Education%20Consultant!5e0!3m2!1sen!2sin!4v1734085901401!5m2!1sen!2sin"
              className="w-full h-full border-0"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </footer>
    </div>
  );
}
